import { render, staticRenderFns } from "./GroupConsentApprove.vue?vue&type=template&id=0806e7a8&scoped=true&"
import script from "./GroupConsentApprove.vue?vue&type=script&lang=js&"
export * from "./GroupConsentApprove.vue?vue&type=script&lang=js&"
import style0 from "./GroupConsentApprove.vue?vue&type=style&index=0&id=0806e7a8&prod&lang=css&"
import style1 from "./GroupConsentApprove.vue?vue&type=style&index=1&id=0806e7a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0806e7a8",
  null
  
)

export default component.exports